const AdminPremiumLessonPlanningIndex = () => import(/* webpackChunkName: "admin" */ '../../pages/admin/premiumLessonPlanning/PremiumLessonPlanningIndex')
const AdminPremiumLessonPlanningRecycleBin = () => import(/* webpackChunkName: "admin" */ '../../pages/admin/premiumLessonPlanning/PremiumLessonPlanningRecycleBin')
const AdminPremiumLessonPlanningManageLessons = () => import(/* webpackChunkName: "admin" */ '../../pages/admin/premiumLessonPlanning/PremiumLessonPlanningManageLessons')
const AdminPremiumLessonPlanningSettings = () => import(/* webpackChunkName: "admin" */ '../../pages/admin/premiumLessonPlanning/PremiumLessonPlanningSettings')

export default [
  {
    path: '/admin/premium-lesson-planning',
    name: 'AdminPremiumLessonPlanning',
    component: AdminPremiumLessonPlanningIndex,
    redirect: { name: 'AdminPremiumLessonPlanningManageLessons', params: { type: 'list' } },
    children: [
      {
        path: 'settings',
        name: 'AdminPremiumLessonPlanningSettings',
        component: AdminPremiumLessonPlanningSettings
      },
      {
        path: 'manage-lessons/recycle-bin',
        name: 'AdminPremiumLessonPlanningRecycleBin',
        component: AdminPremiumLessonPlanningRecycleBin
      },
      {
        path: 'manage-lessons/:type?',
        name: 'AdminPremiumLessonPlanningManageLessons',
        component: AdminPremiumLessonPlanningManageLessons,
        beforeEnter: (to, from, next) => {
          if (to.params.type) next()
          else next({ name: 'AdminPremiumLessonPlanningManageLessons', replace: true, params: { type: 'list' } })
        }
      }
    ]
  }
]
